import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from '../components/ScrollReveal';
import { fetchCollection, getVal } from '../lib/api';

export default function TeltUdlejning() {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    async function loadPageCms() {
      try {
        const res = await fetchCollection('sider', { term: 'sidetype:telt-udlejning' });
        if (res.items && res.items.length > 0) {
          setPageData(res.items[0]);
        }
      } catch (err) {
        console.error('Fejl ved hentning af telt-udlejning fra CMS:', err);
      }
    }
    loadPageCms();
  }, []);
  const subCategories = [
    {
      name: 'Firkantede borde',
      path: '/telt-udlejning/firkantet-bord',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/bord.jpg',
      desc: 'Firkantede borde til 6-8 personer'
    },
    {
      name: 'Runde borde',
      path: '/telt-udlejning/runde-bord',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/runde.jpg',
      desc: 'Runde borde med plads til 8 personer'
    },
    {
      name: 'Stole',
      path: '/telt-udlejning/stole',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/runde_5.jpg',
      desc: 'Sorte stole - kan også stå på græs'
    },
    {
      name: 'Gulv',
      path: '/telt-udlejning/gulv',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/gulv_2.jpg',
      desc: 'Gulv udlejning til telt'
    },
    {
      name: 'Lyskæder',
      path: '/telt-udlejning/lysk-der',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/sirius-lucas-udendrs-lyskde.jpg',
      desc: 'Lyskæder til din fest flere slags'
    },
    {
      name: 'Cafebord',
      path: '/telt-udlejning/cafebord',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/cafebord.jpg',
      desc: 'Højt ståbord / cafebord'
    },
    {
      name: 'Varmeovn (Gas)',
      path: '/udlejning/varmeovn-gas',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/varmeovn-gas.jpg',
      desc: 'Effektiv gasvarmeovn til teltet'
    }
  ];

  return (
    <div className="flex min-h-screen flex-col bg-stone-50">
      <section className="relative overflow-hidden border-b border-stone-200 bg-white py-20">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/forside_4.jpg"
            alt="Telt baggrund"
            className="h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/40" />
        </div>
        <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <ScrollReveal animation="fade-in-down">
            <span className="text-xs font-bold uppercase tracking-[0.35em] text-brand-orange">Fest & arrangementer</span>
            <h1 className="mt-3 text-4xl font-semibold text-slate-800 sm:text-5xl">
              {getVal(pageData?.title) || 'Telt udlejning'}
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-500 sm:text-base">
              {getVal(pageData?.subtitle) || 'Vi har telte fra 6x3 meter op til 6x27 meter.'}
            </p>
          </ScrollReveal>
          <ScrollReveal animation="scale-up" delay={150} className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href="tel:22426011"
              className="rounded-full bg-brand-orange px-6 py-3 text-base font-bold text-white transition-all duration-300 hover:bg-brand-orange-hover hover:-translate-y-0.5 hover:shadow-lg"
            >
              <i className="fa-solid fa-phone mr-2" /> 22 42 60 11
            </a>
            <Link
              to="/kontakt"
              className="rounded-full border border-stone-200 bg-white px-6 py-3 text-base font-bold text-slate-700 transition-all duration-300 hover:border-brand-orange hover:text-brand-orange hover:-translate-y-0.5 hover:shadow-md"
            >
              Forespørg leje
            </Link>
          </ScrollReveal>
        </div>
      </section>

      <section className="bg-stone-50 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-16 grid grid-cols-1 gap-12 lg:grid-cols-2 items-center">
            <ScrollReveal animation="fade-in-left">
              <h2 className="mb-6 text-3xl font-semibold text-slate-800">Professionel teltudlejning</h2>
              <p className="mb-4 text-base leading-relaxed text-slate-500">
                Vi har telte fra 6x3 meter op til 6x27 meter.
              </p>
              <p className="mb-6 text-base leading-relaxed text-slate-500">
                Også med træ gulv.
              </p>
              <div className="mb-8 flex items-center gap-3 text-brand-orange">
                <i className="fa-solid fa-circle-check text-xl animate-pulse-slow" />
                <span className="font-semibold">Vi kommer og sætter op og piller ned igen.</span>
              </div>
              <div className="rounded-[1.5rem] border border-stone-200 bg-white p-6 shadow-[0_12px_30px_rgba(148,163,184,0.08)] transition-all duration-300 hover:shadow-lg">
                <h3 className="mb-2 text-lg font-semibold text-slate-800">Har du spørgsmål eller ønsker et tilbud?</h3>
                <p className="mb-4 text-sm text-slate-500">Ring til os direkte for en uforpligtende snak om dit arrangement.</p>
                <a href="tel:22426011" className="block text-xl font-semibold text-brand-orange transition-colors hover:text-brand-orange-hover">
                  <i className="fa-solid fa-phone mr-2" /> 22 42 60 11
                </a>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-in-right" className="flex justify-center">
              <div className="h-64 w-full overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white sm:h-96 max-w-2xl shadow-md">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/imgi-2-595527187-122169759662785719-5797550808910282226-n.jpg"
                  alt="Telt"
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
            </ScrollReveal>
          </div>

          <div className="mb-16 grid grid-cols-1 gap-12 lg:grid-cols-2 items-center lg:flex-row-reverse">
            <ScrollReveal animation="fade-in-right" className="lg:order-2">
              <h2 className="mb-6 text-3xl font-semibold text-slate-800">Større telt (9x12 meter)</h2>
              <p className="mb-4 text-base leading-relaxed text-slate-500">
                Vi tilbyder også et stort og rummeligt telt på 9x12 meter, som er ideelt til fester og arrangementer.
              </p>
              <p className="mb-4 text-base leading-relaxed text-slate-500">
                Teltet er yderst fleksibelt og kan opdeles i mindre sektioner af 3 meter hver, så det kan tilpasses præcis efter dine behov og pladsforhold.
              </p>
              <p className="mb-6 text-base leading-relaxed text-slate-500">
                Også med træ gulv.
              </p>
              <div className="mb-8 flex items-center gap-3 text-brand-orange">
                <i className="fa-solid fa-circle-check text-xl animate-pulse-slow" />
                <span className="font-semibold">Vi kommer og sætter op og piller ned igen.</span>
              </div>
              <div className="rounded-[1.5rem] border border-stone-200 bg-white p-6 shadow-[0_12px_30px_rgba(148,163,184,0.08)] transition-all duration-300 hover:shadow-lg">
                <h3 className="mb-2 text-lg font-semibold text-slate-800">Få et uforpligtende tilbud</h3>
                <p className="mb-4 text-sm text-slate-500">Ring til os direkte for at høre mere om leje af vores 9x12 m telt.</p>
                <a href="tel:22426011" className="block text-xl font-semibold text-brand-orange transition-colors hover:text-brand-orange-hover">
                  <i className="fa-solid fa-phone mr-2" /> 22 42 60 11
                </a>
              </div>
            </ScrollReveal>

            <ScrollReveal animation="fade-in-left" className="flex justify-center lg:order-1">
              <div className="h-64 w-full overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white sm:h-96 max-w-2xl shadow-md">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image32.jpeg"
                  alt="Telt til 40 personer 9x12 meter"
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
            </ScrollReveal>
          </div>

          <div className="border-t border-stone-200 pt-16">
            <div className="mx-auto mb-12 max-w-xl text-center">
              <ScrollReveal animation="fade-in-down">
                <span className="text-xs font-bold uppercase tracking-[0.35em] text-brand-orange">Vælg tilbehør</span>
                <h3 className="mt-3 text-3xl font-semibold text-slate-800">Borde, stole & belysning</h3>
                <p className="mt-3 text-sm leading-7 text-slate-500">
                  Fuldend dit teltarrangement med vores udvalg af praktiske borde, stole og stemningsfuld belysning.
                </p>
              </ScrollReveal>
            </div>

            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-6">
              {subCategories.map((cat, idx) => {
                // First 3 items span 2 columns each on desktop (lg:col-span-2) - Row 1
                // Last 4 items span 3 columns each on desktop (lg:col-span-3) - Row 2 & 3
                const colSpanClass = idx < 3 ? 'lg:col-span-2' : 'lg:col-span-3';
                return (
                  <ScrollReveal
                    key={cat.path}
                    animation="fade-in-up"
                    delay={idx * 100}
                    className={colSpanClass}
                  >
                    <Link
                      to={cat.path}
                      className="group flex flex-col h-full overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white shadow-[0_12px_30px_rgba(148,163,184,0.08)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:border-brand-orange/30"
                    >
                      <div className="h-48 overflow-hidden bg-stone-100">
                        <img
                          src={`https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=80,format=auto/${cat.image}`}
                          alt={cat.name}
                          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <div className="flex flex-grow flex-col p-6">
                        <h4 className="mb-2 text-lg font-semibold text-slate-800 group-hover:text-brand-orange transition-colors">{cat.name}</h4>
                        <p className="mb-4 text-sm leading-relaxed text-slate-500">{cat.desc}</p>
                        <div className="mt-auto flex items-center justify-between border-t border-stone-200 pt-4 text-xs font-bold uppercase tracking-wider text-brand-orange">
                          <span>Se detaljer</span>
                          <i className="fa-solid fa-chevron-right transition-transform group-hover:translate-x-1" />
                        </div>
                      </div>
                    </Link>
                  </ScrollReveal>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
